import { render, staticRenderFns } from "./widgetHeatmap.vue?vue&type=template&id=3feda302&scoped=true&"
import script from "./widgetHeatmap.vue?vue&type=script&lang=js&"
export * from "./widgetHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./widgetHeatmap.vue?vue&type=style&index=0&id=3feda302&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feda302",
  null
  
)

export default component.exports